import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { SimpleButton } from '../../../../components';
import { validatePromotionCodeWithProductRequest } from '../../../../store/modules/promotion-codes/actions';

const PromoCodeValidateButton = () => {
  const dispatch = useDispatch();
  const { watch } = useFormContext();
  const promotionCode = watch('promo_code');

  const validatePromoCodeHandler = useCallback(() => {
    dispatch(validatePromotionCodeWithProductRequest(promotionCode));
  }, [dispatch, promotionCode]);

  return (
    <SimpleButton
      onClick={validatePromoCodeHandler}
      disabled={!promotionCode}
    >
      Apply Code
    </SimpleButton>
  );
};

export default PromoCodeValidateButton;
